import type { ResolvedAsset } from "@contentful-api/cmsResolvedTypes";
import { isAllowedExternalUrl } from "@contentful-api/helpers/isAllowedExternalUrl";
import { resolveMediaAsset } from "@contentful-api/helpers/resolveMediaAsset";
import type { IMediaAsset } from "@contentful-api/types/contentful";

const toAbsoluteUrl = (url: string): string => (url.startsWith("//") ? `https:${url}` : url);

export const getAssetFileUrl = (
    asset?: IMediaAsset | null,
    image?: ResolvedAsset | null
): string | undefined => {
    const raw = resolveMediaAsset(asset ?? undefined, image ?? undefined)?.url;
    if (!raw || typeof raw !== "string") return undefined;

    const absolute = toAbsoluteUrl(raw.trim());
    return isAllowedExternalUrl(absolute) ? absolute : undefined;
};
